/**
 * @generated SignedSource<<c49915dd2ae8a62fcfa6f7502fb3d4ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CertType = "Kakao" | "Naver";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type simpleAuthRequestTokenMutation$variables = {
  birthday: string;
  certType: CertType;
  name: string;
  phone: string;
};
export type simpleAuthRequestTokenMutation$data = {
  readonly hometaxSimpleAuth: {
    readonly cxId: string | null | undefined;
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly reqTxId: string | null | undefined;
    readonly result: boolean;
    readonly token: string | null | undefined;
  };
};
export type simpleAuthRequestTokenMutation = {
  response: simpleAuthRequestTokenMutation$data;
  variables: simpleAuthRequestTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "birthday"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "certType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phone"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "birthday",
        "variableName": "birthday"
      },
      {
        "kind": "Variable",
        "name": "certType",
        "variableName": "certType"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "phone",
        "variableName": "phone"
      }
    ],
    "concreteType": "HometaxSimpleAuthOutput",
    "kind": "LinkedField",
    "name": "hometaxSimpleAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reqTxId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cxId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "simpleAuthRequestTokenMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "simpleAuthRequestTokenMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "255358cac6c441a3f7f6dfdb650821c1",
    "id": null,
    "metadata": {},
    "name": "simpleAuthRequestTokenMutation",
    "operationKind": "mutation",
    "text": "mutation simpleAuthRequestTokenMutation(\n  $name: String!\n  $phone: String!\n  $birthday: String!\n  $certType: CertType!\n) {\n  hometaxSimpleAuth(name: $name, phone: $phone, birthday: $birthday, certType: $certType) {\n    result\n    reqTxId\n    token\n    cxId\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc5a8ec719faa57c905a1573026c19f0";

export default node;
